export default __webpack_public_path__ + "static/media/ds2.c2dd9658.png";